
import { store } from '@/store'
import { UserMutation } from '@/store/module/user'
import { Device } from '@/store/types'
import { abbreviateNumberW } from '@/utils'
import { RedPacket } from 'vue'
import { Options, Vue } from 'vue-class-component'
import { useI18n } from 'vue-i18n'
import { Getter } from 'vuex-class'

@Options({})
export default class ChangePassView extends Vue {
    @Getter('device') device!: Device

    iN = useI18n().t
    isMobile = false
    $emit!: Vue['emit']
    emitter!: Vue['emitter']

    @Getter('redpackets') redpackets!: RedPacket[]
    @Getter('userId') userId!: string

    count = -1

    //#region Vue Methods

    mounted(): void {
        if (this.redpackets && this.redpackets.length > 0) this.count = 0
    }

    beforeMount(): void {
        this.isMobile = this.device.display === 1
    }
    //#endregion

    close(): void {
        this.count += 1
        if (this.redpackets && this.count >= this.redpackets.length) {
            // emit close
            // commit never show it again
            this.$emit('close')
            store.commit(UserMutation.OFF_RED_PACKETS, false)
        }
    }

    endDate(): string {
        if (
            this.redpackets &&
            this.redpackets.length > 0 &&
            this.count !== -1 &&
            this.count <= this.redpackets.length - 1
        ) {
            return this.redpackets[this.count].endTime
        }

        return ''
    }

    message(): string {
        if (
            this.redpackets &&
            this.redpackets.length > 0 &&
            this.count !== -1 &&
            this.count <= this.redpackets.length - 1
        ) {
            return this.redpackets[this.count].remark
        }

        return ''
    }

    amount(): string {
        if (
            this.redpackets &&
            this.redpackets.length > 0 &&
            this.count !== -1 &&
            this.count <= this.redpackets.length - 1
        ) {
            return abbreviateNumberW(this.redpackets[this.count].amount)
        }

        return ''
    }
}
